import { useMutation } from '@tanstack/react-query';
import {
  runAvailabilitySlotMatch,
  type RunSlotMatchPayload,
  type RunSlotMatchResponse,
} from '../services/matchService';

export function useRunSlotMatchMutation() {
  return useMutation<RunSlotMatchResponse, Error, RunSlotMatchPayload>({
    mutationFn: runAvailabilitySlotMatch,
  });
}

